<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('qty')"
      prop="qty"
      :rules="getValidationRule('required,number')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.qty"
        @input="form.qty = valueInteger($event)"
        @change="updateModelItem('qty', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('partNumber')"
      prop="partNumber"
      :rules="getValidationRule('required')"
      class="material-style">
      <el-input
        :value="form.partNumber"
        @input="form.partNumber = valueTrimLeft($event)"
        @change="updateModelItem('partNumber', { required: false })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('part-description')"
      prop="partDescription"
      class="material-style">
      <el-input
        :value="form.partDescription"
        @input="form.partDescription = valueTrimLeft($event)"
        @change="updateModelItem('partDescription', { required: false })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('price')"
      prop="price"
      :rules="getValidationRule('number')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.price"
        @input="form.price = valueNumber($event)"
        @change="updateModelItem('price', { required: false })"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormReplacement',
  mixins: [Form]
}
</script>
